import { Routes } from '@angular/router'
import { canViewTasksGuard, hasAccountGuard, hasTokenGuard } from './guards'
import featureRoutes from './feature/routes'

const publicRoutes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./login/login.component').then((m) => m.LoginComponent),
    pathMatch: 'full',
  },
  {
    path: 'register',
    loadComponent: () => import('./containers/light-container/light.container').then((m) => m.LightContainer),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./register/register.component').then((m) => m.RegisterComponent),
      },
    ],
  },
  {
    path: 'sign-up',
    loadComponent: () => import('./containers/dark-container/dark.container').then((m) => m.DarkContainer),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./signUp/sign-up.component').then((m) => m.SignupComponent),
      },
      {
        path: 'invitation',
        loadComponent: () =>
          import('./signUp/invitation/invitation.component').then((m) => m.SignupInvitationComponent),
      },
    ],
  },
  {
    path: 'password-reset',
    loadComponent: () => import('./containers/light-container/light.container').then((m) => m.LightContainer),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./components/auth/password-reset/password-reset.component').then((m) => m.PasswordResetComponent),
      },
    ],
  },
  {
    path: 'password-change',
    loadComponent: () => import('./containers/light-container/light.container').then((m) => m.LightContainer),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./password-change/required-password-change.component').then((m) => m.RequirePasswordChangeComponent),
      },
    ],
  },
]

const privateRoutes: Routes = [
  {
    path: '',
    canActivate: [hasTokenGuard],
    canActivateChild: [hasAccountGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./root-redirect/root-redirect.component').then((m) => m.RootRedirectComponent),
      },
      {
        path: 'organizations',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./organizations/organizations.component').then((m) => m.OrganizationsComponent),
          },
          {
            path: ':organizationId',
            data: {
              title: 'Assets',
            },
            loadComponent: () => import('./home/home.component').then((m) => m.HomeComponent),
            children: [
              {
                path: 'settings',
                canActivate: [hasTokenGuard],
                canActivateChild: [hasAccountGuard],
                loadChildren: () => import('./admin/routes'),
                data: {
                  title: 'Admin',
                  showHeader: false,
                },
              },
              {
                path: 'account',
                loadChildren: () => import('./account-settings/routes'),
                data: {
                  title: 'Account Settings',
                  showHeader: false,
                },
              },
              {
                path: 'maps/:mapId',
                loadComponent: () => import('./map-layout/map-layout.component').then((m) => m.MapLayoutComponent),
                children: [
                  {
                    path: '',
                    loadComponent: () => import('./editor/editor.component').then((m) => m.EditorComponent),
                    children: featureRoutes,
                  },
                  {
                    title: 'Ziptility - Dispatch',
                    path: 'tasks',
                    canActivate: [canViewTasksGuard],
                    loadChildren: () => import('./tasks/routes'),
                  },
                  {
                    title: 'Ziptility - Tasks Reports',
                    path: 'tasks',
                    loadChildren: () => import('./tasks/report-routes'),
                  },
                  {
                    title: 'Ziptility - Asset Reports',
                    path: 'assets',
                    loadChildren: () => import('./asset-list/asset-report-routes'),
                  },
                  {
                    path: 'routines',
                    data: {
                      title: 'Routines',
                    },
                    loadChildren: () => import('./routines/routes'),
                  },
                  {
                    path: 'inventory',
                    data: {
                      title: 'Inventory',
                      showHeader: false,
                    },
                    loadChildren: () => import('./inventory/routes'),
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: '**',
        loadComponent: () => import('./root-redirect/root-redirect.component').then((m) => m.RootRedirectComponent),
      },
    ],
  },
]

export const appRoutes: Routes = [...publicRoutes, ...privateRoutes]
